import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Text,
  IconButton,
  Spacer,
  HStack,
} from '@chakra-ui/react';
import { CloseCircleOutline, formatNumber, useToast } from '@aslanpay/portal-common-lib';
import { useManagingCompanyStore } from 'app/store';

import TopUpPotForm from './TopUpPotForm/TopUpPotForm';
import { TopUpPotModalProps } from './TopUpPotModal.types';
import { TransferPotInfo } from './TopUpPotForm/TopUpPotForm.types';

function TopUpPotModal({ isOpen, onClose, originPot }: TopUpPotModalProps) {
  const company = useManagingCompanyStore((state) => state.company);

  const toast = useToast();

  const companyId = company?.id || '';

  const onSuccess = ({ fromPotName, toPotName, points }: TransferPotInfo) => {
    toast({
      position: 'top-right',
      title: `${toPotName} has been topped up with ${formatNumber(points)} points`,
      description: `Both ${fromPotName} and ${toPotName} balances have been updated.`,
      status: 'success',
    });

    onClose();
  };

  const onError = ({ fromPotName, toPotName }: TransferPotInfo) => {
    toast({
      position: 'top-right',
      title: 'Failed to top-up pot',
      description: `Could not transfer points from ${fromPotName} to ${toPotName}.`,
      status: 'error',
    });
  };

  if (!originPot) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl" isCentered>
      <ModalOverlay />
      <ModalContent maxW="592px" w="592px">
        <ModalHeader pb={4}>
          <HStack align="flex-start">
            <Text as="h6" textStyle="h6SemiBold" color="brand.black">
              Top-up pot
            </Text>

            <Spacer />
            <IconButton
              variant="link"
              icon={<CloseCircleOutline boxSize="30px" />}
              aria-label="Close top-up pot modal"
              onClick={onClose}
            />
          </HStack>

          <Text fontSize="16px" textColor="brand.gray" fontWeight="400" pt="5px">
            {`Add points to ${originPot.name} from the company wallet, a pride's pot or another campaign's.`}
          </Text>
        </ModalHeader>

        <ModalBody pb={6}>
          <TopUpPotForm
            onClose={onClose}
            onError={onError}
            onSuccess={onSuccess}
            companyId={companyId}
            originPot={originPot}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default TopUpPotModal;
